import { Component, OnInit } from '@angular/core';
import { PromocaoService } from './../../services/promocao.service';

@Component({
  selector: 'app-promo-list',
  templateUrl: './promo-list.component.html',
  styleUrls: ['./promo-list.component.scss']
})
export class PromoListComponent implements OnInit {
  public promocoes;

  constructor(
    private promocao: PromocaoService
  ) { }

  ngOnInit() {
    if (localStorage.getItem("promocao") === null) {
      this.promocao.listPromo()
        .subscribe(
          (response: any) => {
            localStorage.setItem('promocao', JSON.stringify(response));
            this.promocoes = response.reverse();
            this.loadPromocao();
          }
        );
    } else {
      this.promocoes = JSON.parse(localStorage.promocao).reverse();
      this.loadPromocao();
    }
  }

  loadPromocao() {
    const atualtime = new Date();

    this.promocoes = this.promocoes.filter(promocao => {
      let inicio = {
        "day": parseInt(promocao.INICIO.slice(0, 2)),
        "month": parseInt(promocao.INICIO.slice(2, 4)),
        "year": parseInt(promocao.INICIO.slice(4, 8)),
      };

      let fim = {
        "day": parseInt(promocao.FIM.slice(0, 2)),
        "month": parseInt(promocao.FIM.slice(2, 4)),
        "year": parseInt(promocao.FIM.slice(4, 8)),
      };

      let dinicio = new Date(inicio.year, (inicio.month - 1), inicio.day);
      let dfim = new Date(fim.year, (fim.month - 1), fim.day);

      if (promocao.Acao == 'Interno' && dinicio < atualtime && dfim > atualtime) {
        return promocao;
      }
    });
  }

}
